import {useForm} from "react-hook-form";
import React, {useCallback, useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import ProjectForm from "../../../Components/Forms/Pages/Project/Project/ProjectForm";
import {addProject, getAllProjectCategories} from "../../../Services/Project/ProjectService";
import SnackbarContext from "../../../Context/SnackbarContext";
import { getPartners } from "../../../Services/CRM/PartnerService";

const formRules = {
    'name': {required: true},
    'projectCategory': {required: true},
}

const AddProject = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({defaultValues: {
            startDate: NaN,
            endDate: NaN,
        }});
    const {data, handleSubmit, getValues, setValue, trigger, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [projectCategories, setProjectCategories] = useState([]);
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.project.project.addProject.pageTitle);
    });

    useEffect(() => {
        fetch();
        fetchPartners();
    }, [])

    const fetch = useCallback(() => {
        getAllProjectCategories({}).then(response => {
            if (!response || !response.ok) {
                return;
            }
            setProjectCategories(response.data)
        });
    }, [])

    const fetchPartners = (term = '') => {
        getPartners({term}).then(response => {
            if(!response || !response.ok){
                return;
            }
            setPartners(response.data.result);
        })
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addProject(data).then(response => {
            setShowLoader(false);
            console.log(data)

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish(response.data.entity);
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ProjectForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue} trigger={trigger}
                projectCategories={projectCategories} partners={partners}
                errors={errors} data={data} form={form} onChangePartnerFilter={fetchPartners}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddProject;